function NotFound() {
    return(
        <div>You seem lost</div>
    )
}

export default NotFound;